<template>
  <div class='distributor' v-loading='importLoading'>
    <div class='nav'>
      <el-form :model='form' label-width='60px' :inline='true' class='demo-form-inline flex1'>
        <el-form-item label='经销商:'>
          <el-input v-model='form.shorterName' size='mini' placeholder='请输入经销商'></el-input>
        </el-form-item>
        <el-form-item label='状态:'>
          <el-select v-model='form.status' filterable size='mini' placeholder='全部'>
            <el-option label='全部' value=''></el-option>
            <el-option label='启用中' value='1'></el-option>
            <el-option label='禁用中' value='0'></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='addBtn'>新增</el-button>
        </el-form-item>

      </el-form>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <div style='display: flex;justify-content: flex-end;'>
          <span class='el-icon-download el-icon--right'
                style='cursor:pointer;font-size: 16px;margin-right: 20px;color: rgba(51, 136, 255, 1);display: flex;align-items: center;'
                @click='download'>模板下载</span>
          <span style='cursor: pointer'>
            <el-upload
              ref='upload'
              class='upload-demo'
              style='color: rgba(51, 136, 255, 1);'
              :action='uploadUrl'
              :auto-upload='true'
              :show-file-list='false'
              :data='uploadData'
              :on-success='planOnSuccess'
              :before-upload='beforeUpload'>
              <i class='el-icon-upload el-icon--right'>批量导入</i>
            </el-upload>
          </span>
        </div>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50px' type='index'
                           :index='tableIndexMethod'>
          </el-table-column>
          <el-table-column prop='shorterName' label='经销商全称' min-width='150' align='center' />
          <el-table-column prop='fullName' label='经销商简称' min-width='150' align='center' />
          <el-table-column prop='telephone' label='联系电话' min-width='120' align='center' />
          <el-table-column prop='mailbox' label='邮箱' min-width='120' align='center' />
          <!-- <el-table-column prop="dockingPersonName" min-width="100" label="负责人姓名" align="center"/>
          <el-table-column prop="dockingPersonTel" min-width="120" label="负责人电话" align="center"/> -->
          <el-table-column prop='status' label='状态' align='center' min-width='70'>
            <template slot-scope='scope'>
              {{ scope.row.status |stats }}
            </template>
          </el-table-column>
          <el-table-column label='操作' min-width='350' align='center'>
            <template slot-scope='scope'>
              <div style='align-items:center;'>
                <el-button size='mini' class='searchBtn'
                           @click='detailsClick(scope.row.id, scope.row)'>详情
                </el-button>
                <el-button size='mini' type='danger' @click='DisableClick(scope.row.id, scope.row)'
                           v-if='scope.row.status==1'>禁用
                </el-button>
                <el-button size='mini' type='primary' @click='EnableClick(scope.row.id, scope.row)'
                           v-if='scope.row.status==0'>启用
                </el-button>
                <el-button size='mini' class='yellow-bg' @click='modifyClick(scope.row)'>修改
                </el-button>
                <el-button size='mini' class='yellow-bg' @click='addressClick(scope.row)'>地址管理
                </el-button>
                <el-button size='mini' type='info' @click='deleteClick(scope.row.id)'>删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='form.page'
          :page-size='form.rows'
        />
      </div>
    </div>

    <el-dialog :title='`${dialogTitle}经销商`' :visible.sync='addflag' width='623px'
               :close-on-click-modal='false' center @close='dialogClose'>
      <div class='add'>
        <el-form :model='addform' label-width='100px' :rules='rules' ref='ruleForm'
                 class='demo-ruleForm'>
          <div-border label='基础信息' style='padding:20px 20px 20px 10px'>
            <el-form-item label='经销商全称:' prop='distributor'>
              <el-input size='mini' v-model='addform.distributor' placeholder='请输入经销商全称'></el-input>
            </el-form-item>
            <el-form-item label='经销商简称:' prop='distributorAbb'>
              <el-input size='mini' v-model='addform.distributorAbb'
                        placeholder='请输入经销商简称'></el-input>
            </el-form-item>
            <el-form-item label='邮箱:' prop='mailbox'>
              <el-input size='mini' v-model='addform.mailbox' placeholder='请输入邮箱'></el-input>
            </el-form-item>
            <el-form-item label='电话:' prop='telephone'>
              <el-input size='mini' v-model='addform.telephone' placeholder='请输入电话'></el-input>
            </el-form-item>
            <!-- <el-form-item label="负责人姓名:" prop="principal">
              <el-input size="mini" v-model="addform.principal" placeholder="请输入负责人姓名"></el-input>
            </el-form-item>
            <el-form-item label="负责人电话:" prop="principalTel">
              <el-input size="mini" v-model="addform.principalTel" placeholder="请输入负责人电话"></el-input>
            </el-form-item> -->
          </div-border>
          <div-border v-if="dialogTitle!='修改'" label='地址信息' style='padding:20px 20px 20px 10px'>
            <div v-for='(item,index) in addform.addressList' :key='index'>
              <el-row>
                <el-col :span='12'>
                  <el-form-item class='required' label='所在区域:'>
                    <el-cascader ref='area' v-model='item.area' :options='regionList'
                                 style='width:100%' :props="{
                      expandTrigger: 'hover',
                      value: 'id',
                      label: 'cityName',
                      children: 'children',
                      multiple: false,
                    }" size='mini' collapse-tags clearable filterable placeholder='请选择所在区域' />
                  </el-form-item>
                </el-col>
                <el-col :span='12'>
                  <el-form-item class='required' label='详细地址:'>
                    <el-input size='mini' v-model='item.address' placeholder='请输入地址' />
                  </el-form-item>
                </el-col>
                <el-col :span='12'>
                  <el-form-item class='required' label='标识:'>
                    <el-input size='mini' v-model='item.mark' placeholder='请输入标识' />
                  </el-form-item>
                </el-col>
                <el-col :span='12'>
                  <div class='add-team' @click='addTeam'>+</div>
                  <div v-if='addform.addressList.length>1' class='del-team el-icon-close'
                       @click='delTeam(index)'></div>
                </el-col>
              </el-row>
            </div>
          </div-border>
        </el-form>
        <div class='btnContainer'>
          <el-button size='medium' class='searchBtn' :loading='addLoad' @click='addClick()'>
            {{ dialogTitle }}
          </el-button>
          <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title='详情' :visible.sync='detailShow' width='623px' center
               :close-on-click-modal='false'>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
            <p>{{ detailData.status|stats }}</p>
          </div>
          <div class='baseInfoContent'>
            <div>
              <el-form :model='detailData' label-position='left'>
                <el-form-item label='经销商全称：'>
                  {{ detailData.shorterName }}
                </el-form-item>
                <el-form-item label='经销商简称：'>
                  {{ detailData.fullName }}
                </el-form-item>
                <el-form-item label='联系电话：'>
                  {{ detailData.telephone }}
                </el-form-item>
                <el-form-item label='邮箱：'>
                  {{ detailData.mailbox }}
                </el-form-item>
                <!-- <el-form-item label="负责人姓名：">
                  {{detailData.dockingPersonName}}
                </el-form-item>
                <el-form-item label="创建负责人电话：">
                  {{detailData.dockingPersonTel}}
                </el-form-item> -->
              </el-form>
            </div>
          </div>
          <div class='operation'>
            <div class='operationTitle'>
              <div class='line' />
              <span>地址详情</span>
            </div>
            <div class='baseInfoTable'>
              <el-table :data='detailData.addressList' border max-height='300'>
                <el-table-column label='序号' align='center' width='50px' type='index' />
                <el-table-column prop='identify' label='位置标识' align='center' width='160px' />
                <el-table-column prop='regionName' label='所在区域' align='center' />
                <el-table-column prop='address' label='详细地址' align='center' />
              </el-table>
            </div>
          </div>
          <div class='operation'>
            <div class='operationTitle'>
              <div class='line' />
              <span>操作记录</span>
            </div>
            <div class='baseInfoTable'>
              <el-table :data='detailData.operateRecordList' border max-height='300'>
                <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
                <el-table-column prop='operateType' label='操作类型' align='center' />
                <el-table-column prop='operationName' label='操作人' align='center' />
                <el-table-column prop='remark' label='备注' align='center' />
              </el-table>
            </div>
          </div>
        </div>
      </div>

    </el-dialog>
    <el-dialog title='地址管理' :visible.sync='addressShow' width='700px' center
               :close-on-click-modal='false'>
      <div class='address'>
        <div class='baseInfo'>
          <div class='baseInfoTable'>
            <el-table :data='addressData' border stripe size='mini' max-height='300'
                      :header-cell-style="{'color':'#7F7F7F','font-size':'13px','height':'48px','background-color':' #E8E8E8'}"
                      :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}">
              <el-table-column label='序号' align='center' width='50px' type='index' />
              <el-table-column prop='identify' label='位置标识' align='center'>
                <template slot-scope='scope'>
                  <el-input size='mini' v-model='scope.row.identify' placeholder='请输入位置标识' />
                </template>
              </el-table-column>
              <el-table-column prop='regionFullId' min-width='140' label='所在区域' align='center'>
                <template slot-scope='scope'>
                  <el-cascader :ref="'region'+scope.$index" v-model='scope.row.regionFullId'
                               :options='regionList' style='width:100%' :props="{
                    expandTrigger: 'hover',
                    value: 'id',
                    label: 'cityName',
                    children: 'children',
                    multiple: false,
                  }" size='mini' collapse-tags clearable filterable placeholder='请选择所在区域' />
                </template>
              </el-table-column>
              <el-table-column prop='address' label='详细地址' align='center'>
                <template slot-scope='scope'>
                  <el-input size='mini' v-model='scope.row.address' placeholder='请输入详细地址' />
                </template>
              </el-table-column>
              <el-table-column label='操作' align='center'>
                <template slot-scope='scope'>
                  <!-- el-icon-check -->
                  <span class='el-icon-circle-plus'
                        @click="addAddress(scope.row,scope.$index,'add')"></span>
                  <span v-if='!scope.row.flg' style='color:#46bb87' class='el-icon-success'
                        @click="addAddress(scope.row,scope.$index,'confirm')"></span>
                  <span v-if='scope.row.flg' class='el-icon-edit-outline edit-style'
                        @click='reviseAddress(scope.row,scope.$index)'></span>
                  <span class='el-icon-error' @click='delAddress(scope.row,scope.$index)'></span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import {
    distributorPageList,
    distributorAdd,
    distributorAddress,
    addAddress,
    reviseAddress,
    delAddress,
    distributorIsEnable,
    distributorDetail,
    distributorDelete,
    distributorUpdate,
  } from '@/service/basicfile';
  import { formatTime } from '@/config/mUtils';
  import popup from '@/components/popup';
  import selectMap from '@/components/map';
  import divBorder from '@/components/divBorder';
  import { getSessionStore } from '@/config/mUtils';
  import { getImport, getImportUrl } from '@/service/getIP';

  export default {
    components: {
      popup,
      selectMap,
      divBorder,
    },

    data() {
      const checkEmail = (rule, value, cb) => {
        // 当数据为空时，不进行校验
        if (!value) {
          return cb();
        }
        const regEmail = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
        if (regEmail.test(value)) {
          // 合法的输入
          return cb();
        }
        cb(new Error('请输入合法的邮箱!'));


      };
      const checkMobile = (rule, value, cb) => {
        // 当数据为空时，不进行校验
        if (!value) {
          console.log(value);
          return cb();
        }
        const regMobile = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/;
        if (regMobile.test(value)) {
          // 合法的输入
          return cb();
        }
        cb(new Error('清输入合法的手机号!'));


      };
      return {
        importLoading: false,
        form: {
          shorterName: '',
          status: '',
          page: 1,
          rows: 10,

        },
        total: 0,
        tableLoad: false,
        TableDatas: [],
        addform: {
          distributor: '',
          distributorAbb: '',
          telephone: '',
          mailbox: '',
          principal: '',
          principalTel: '',
          addressList: [{
            address: '',
            area: '',
            mark: '',
          }],
        },
        regionList: [],  // 区域
        detailData: {},
        dialogTitle: '',
        operationData: [],
        detailShow: false,
        showMap: false,
        addLoad: false,
        modifyform: {
          name: '',
          remark: '',
        },
        DialogVisible: false,
        addflag: false,
        modifyflag: false,
        modifyId: '',
        rules: {
          distributor: {
            required: true,
            message: '请输入经销商全称',
            trigger: 'blur',
          },
          distributorAbb: {
            required: true,
            message: '请输入经销商简称',
            trigger: 'blur',
          },
          address: {
            required: true,
            message: '请输入地址',
            trigger: 'blur',
          },
          mailbox: {
            validator: checkEmail,
            trigger: 'blur',
          },
          telephone: {
            validator: checkMobile,
            trigger: 'blur',
          },
        },
        addressShow: false,  // 地址管理
        addressData: [],  // 地址管理数据
        basicId: '',    // 地址管理id
        // 批量导入
        uploadUrl: '',//导入地址
        uploadData: {
          file: '',
        },
      };

    },
    filters: {
      createTimeFormat: function(value) {
        if (value) {
          return formatTime(value, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }

      },
      stats(val) {
        let text = '';
        switch (val) {
          case 1:
            text = '启用中';
            break;
          case 0:
            text = '禁用中';
            break;
        }
        return text;
      },
    },
    created() {
      this.$nextTick(() => {
        this._distributorPageList();
        this.regionList = JSON.parse(getSessionStore('areaList'));
        this.uploadUrl = getImportUrl('/distributor/batchAddDistributor');
      });
    },
    methods: {
      async _distributorPageList() {
        this.tableLoad = true;
        let res = await distributorPageList(this.form);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      async detailsClick(id) {
        this.detailShow = true;
        let res = await distributorDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
      },
      searchBtn() {
        this.form.page = 1;
        this._distributorPageList();
      },
      resetBtn() {
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = '';
        }
        this.form.page = 1;
        this.form.rows = 10;

      },
      tableIndexMethod(index) {
        return this.form.rows * (this.form.page - 1) + index + 1;
      },
      // 添加
      addBtn() {
        this.dialogTitle = '添加';
        this.addflag = true;
      },
      contractSizeChange(row) {
        this.form.rows = row;
        this._distributorPageList();
      },
      contractCurrentChange(page) {
        this.form.page = page;
        this._distributorPageList();
      },
      // 删除
      deleteClick(id) {
        this.$confirm('确认要删除当前数据吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await distributorDelete(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._distributorPageList();
          })
          .catch(() => {
          });
      },
      // 启用
      EnableClick(id, row) {
        this.$confirm('确认要启用当前数据吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await distributorIsEnable(id);
            if (res.status !== 0) {
              return this.$message.error(res.message);

            }
            await this._distributorPageList();
            this.$message.success(res.message);

          })
          .catch(() => {
          });
      },
      // 禁用
      DisableClick(id, row) {
        this.$confirm('确认要禁用当前数据吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await distributorIsEnable(id);
            if (res.status !== 0) {
              return this.$message.error(res.message);
            }
            await this._distributorPageList();
            this.$message.success(res.message);


          })
          .catch(() => {
          });
      },
      // 添加地址
      addTeam() {
        if (this.addform.addressList.length === 0) {
          return this.$message.warning('请填写选择一个地址信息！');
        } else {
          let temp = false;
          if (this.addform.addressList.length > 0) {
            this.addform.addressList.forEach(item => {
              for (let teamKey in item) {
                if (!item[teamKey] || item[teamKey] == '') temp = true;
              }
            });
          }
          if (temp) return this.$message.warning('地址信息必填项数据不能为空！');
        }
        this.addform.addressList.push({
          area: '',
          address: '',
          mark: '',
        });
      },
      // 删除地址
      delTeam(index) {
        this.addform.addressList.splice(index, 1);
      },
      // 新增/修改 —— 确认按钮
      async addClick() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            if (this.addform.addressList && this.addform.addressList.length === 0) {
              return this.$message.warning('请填写选择一个地址信息！');
            } else {
              let temp = false;
              if (this.addform.addressList && this.addform.addressList.legnth > 0) {
                this.addform.addressList.forEach(item => {
                  for (let teamKey in item) {
                    if (!item[teamKey] || item[teamKey] == '') temp = true;
                  }
                });
              }
              if (temp) return this.$message.warning('地址信息必填项数据不能为空！');
            }
            let arr = [];
            if (this.addform.addressList && this.addform.addressList.length > 0) {
              this.addform.addressList.forEach((item, index) => {
                let area = this.$refs['area'][index].getCheckedNodes()[0];
                arr.push({
                  identify: item.mark,
                  regionId: area.value,
                  regionFullId: area.path.join('/'),
                  regionName: area.pathLabels.join('/'),
                  regionCoordinate: area.data.center,
                  address: item.address,
                });
              });
            }
            let {
              distributor,
              distributorAbb,
              telephone,
              mailbox,
            } = this.addform;
            // let {distributor,distributorAbb,telephone,mailbox,principal,principalTel} =this.addform;
            let data = {
              shorterName: distributor,   // 全称
              fullName: distributorAbb,   // 简称
              telephone: telephone,    // 电话
              mailbox: mailbox,    // 邮箱
              // dockingPersonName:principal,    // 负责人姓名
              // dockingPersonTel:principalTel,    // 负责人电话
              addressList: arr,   // 地址信息
            };
            this.addLoad = true;
            if (this.dialogTitle === '添加') {
              let res = await distributorAdd(data);
              this.addLoad = false;
              if (res.status !== 0) {
                return this.$message.error(res.message);
              }
              this.$message.success(res.message);
              await this._distributorPageList();
            } else {
              data.id = this.addform.id;
              let res2 = await distributorUpdate(data);
              this.addLoad = false;
              if (res2.status !== 0) {
                return this.$message.error(res2.message);
              }
              this.$message.success(res2.message);
              await this._distributorPageList();
            }
            this.dialogClose();
          } else {
            console.log('error submit!!');
          }
        });

      },
      dialogClose() {
        this.$refs.ruleForm.resetFields();
        this.addflag = false;
        for (let argumentsKey in this.addform) {
          if (argumentsKey = 'addressList') {
            this.addform[argumentsKey] = [{
              mark: '',
              address: '',
              area: '',
            }];
          } else {
            this.addform[argumentsKey] = '';
          }
        }
      },
      // 修改
      async modifyClick(row) {
        this.dialogTitle = '修改';
        let res = await distributorDetail(row.id);
        if (res.status !== 0) return this.$message.error(res.message);
        let {
          dockingPersonName,
          dockingPersonTel,
          fullName,
          id,
          mailbox,
          shorterName,
          telephone,
        } = res.data;
        this.addform = {
          id: id,
          distributor: shorterName,
          distributorAbb: fullName,
          telephone: telephone,
          mailbox: mailbox,
          // principal:dockingPersonName,
          // principalTel:dockingPersonTel,
        };
        this.addflag = true;
      },
      // 地址管理
      async addressClick(row) {
        if (row && row.id) {
          this.basicId = row.id;
        }
        let obj = { 'basicId': this.basicId };
        let res = await distributorAddress(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        if (res.data.length > 0) {
          res.data.forEach(item => {
            if (item.regionFullId.search('/') != -1) {
              item.regionFullId = item.regionFullId.split('/') || [];
            } else {
              item.regionFullId = item.regionFullId.split(',') || [];
            }
            item.flg = true;
          });
        }
        this.addressData = res.data;
        this.addressShow = true;
      },
      // 地址管理 —— 添加地址
      async addAddress(row, index, type) {
        if (type == 'add') {
          let temp = false;
          if (this.addressData.length > 0) {
            this.addressData.forEach(item => {
              if (!item['identify'] || item['identify'] == '' || item['identify'] == []) temp = true;
              if (!item['regionFullId'] || item['regionFullId'] == '' || item['regionFullId'] == []) temp = true;
              if (!item['address'] || item['address'] == '' || item['address'] == []) temp = true;
            });
          }
          if (temp) {
            return this.$message.warning('地址信息必填项数据不能为空！');
          } else {
            this.addressData.push({
              identify: '',
              regionFullId: '',
              flg: false,
              address: '',
            });
          }
        } else {
          if (!row.identify || row.identify == '' || !row.address || row.address == '' || !row.regionFullId || row.regionFullId == '' || row.regionFullId == []) {
            return this.$message.warning('地址信息必填项数据不能为空！');
          }
          let region = this.$refs['region' + index].getCheckedNodes()[0];
          let obj = {
            basicId: this.basicId,
            identify: row.identify,
            regionId: region.value,
            regionFullId: row.regionFullId ? row.regionFullId.join('/') : '',
            regionName: region.pathLabels.join('/'),
            regionCoordinate: region.data.center,
            address: row.address,
          };
          let res = await addAddress(obj);
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.addressClick();
        }
      },
      // 地址管理 —— 修改地址
      async reviseAddress(row, index) {
        let region = this.$refs['region' + index].getCheckedNodes()[0];
        let obj = {
          basicId: this.basicId,
          id: row.id,
          identify: row.identify,
          regionId: region.value,
          regionFullId: row.regionFullId ? row.regionFullId.join('/') : '',
          regionName: region.pathLabels.join('/'),
          regionCoordinate: region.data.center,
          address: row.address,
        };
        let res = await reviseAddress(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.addressClick();
      },
      // 地址管理 —— 删除地址
      async delAddress(row, index) {
        if (row.flg) {
          let res = await delAddress(row.id);
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.addressClick();
        } else {
          this.addressData.splice(index, 1);
        }
      },
      //模板下载
      download() {
        window.location.href = '/file/经销商导入模板.xlsx';
      },
      // 批量导入
      planOnSuccess(res) {
        this.importLoading = false;
        // if (res.status !== 0) return  this.$message.error(res.message);
        // this.$message.success(res.message);
        // this.TableDatas = res.data;
        // this._distributorPageList();
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            this.TableDatas = res.data;
            await this._distributorPageList();
          },
        });
      },
      beforeUpload(file) {
        let len = file.name.split('.').length;
        if (file.name.split('.')[len - 1] == 'xls' || file.name.split('.')[len - 1] == 'xlsx') {
          this.uploadData.file = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
    },
  };
</script>


<style lang='scss' scoped>
  .distributor {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    /*height: 100%;*/
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {

    }

    .paginationContainer {
      margin-top: 20px;
    }

    ::v-deep.add {
      padding: 26px 40px;

      .add-team {
        position: relative;
        display: inline-block;
        margin-left: 25px;
        width: 20px;
        height: 20px;
        font-size: 20px;
        line-height: 18px;
        top: 11px;
        background: #a4adb3;
        color: #fff;
        text-align: center;
        border-radius: 3px;
        cursor: pointer;
      }

      .del-team {
        position: relative;
        display: inline-block;
        margin-left: 15px;
        width: 20px;
        height: 20px;
        font-size: 13px;
        font-weight: 700;
        line-height: 20px;
        top: 11px;
        background: #a4adb3;
        color: #fff;
        text-align: center;
        border-radius: 50%;
        cursor: pointer;
      }

      .el-input {
        width: 100%;
      }

      .el-form-item__label {
        /*color: #060606;*/
        font-weight: 700;
      }

      .el-form-item {
        margin-bottom: 10px;
      }
    }

    ::v-deep .detail {

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 20px 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .el-form-item {
            margin-bottom: 2px;

            .el-form-item__label {
              /*color: #060606;*/
              font-weight: 700;
            }
          }

        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }

      .el-table td {
        padding: 3px 0px;
        font-size: 13px;
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 25px;
      margin-top: 35px;

      button {
        margin: 0 15px;
      }
    }

    ::v-deep .address {
      width: 100%;
      padding: 30px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .el-form-item {
            margin-bottom: 2px;

            .el-form-item__label {
              /*color: #060606;*/
              font-weight: 700;
            }
          }
        }
      }

      .el-table td {
        padding: 3px 0px;
        font-size: 13px;

        .el-form-item {
          margin-bottom: 0px;
        }
      }

      th.gutter {
        background: #e8e8e8;
      }

      .el-table td .cell > span {
        display: inline-block;
        width: 25px;
        height: 25px;
        line-height: 25px;
        font-size: 25px;
        margin: 0 3px;
        vertical-align: top;

        &:first-child {
          color: #335483;
        }

        &:last-child {
          color: #909399;
        }

        &.edit-style {
          background: #ff9933;
          color: #fff;
          border-radius: 50%;
          font-size: 16px;
          width: 22px;
          height: 22px;
          line-height: 22px;
          margin-top: 1px;
        }
      }
    }

  }

  ::v-deep {
    span.el-icon-download.el-icon--right {
      font-size: 16px;
      text-decoration: underline;
    }

    span i.el-icon-upload.el-icon--right {
      font-size: 16px;
      text-decoration: underline;
    }

    .required label.el-form-item__label::before {
      content: '*';
      margin-right: 4px;
      color: #F56C6C;
    }

    table .cell button.el-button {
      margin: 3px;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      color: #606266;
      max-height: 70vh;
      overflow-y: auto;
    }


  }
</style>
